/**
 * Checks to see if there is a hash symbol that isn't at the very beginning
 *
 * @param str - The string with possible hashtags in it
 * @returns true if there is a hash symbol that isn't the first character
 */
export function checkHashSymbolWithinHashtag(str: string): boolean {
    return str.substring(1).includes('#');
}
